import { formatDistanceToNow } from 'date-fns'

/**
 * Safely formats a date string using formatDistanceToNow
 * @param dateString - The date string to format
 * @param fallback - The fallback text to show if date is invalid
 * @param options - Options to pass to formatDistanceToNow
 * @returns Formatted date string or fallback text
 */
export function safeFormatDistanceToNow(
  dateString: string | null | undefined,
  fallback: string = 'Unknown',
  options?: { addSuffix?: boolean }
): string {
  if (!dateString) {
    return fallback
  }

  try {
    const date = new Date(dateString)
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return fallback
    }

    return formatDistanceToNow(date, options)
  } catch (error) {
    console.warn('Error formatting date:', error)
    return fallback
  }
}

/**
 * Checks if a date string is valid
 * @param dateString - The date string to validate
 * @returns true if the date is valid, false otherwise
 */
export function isValidDate(dateString: string | null | undefined): boolean {
  if (!dateString) {
    return false
  }

  try {
    const date = new Date(dateString)
    return !isNaN(date.getTime())
  } catch {
    return false
  }
}
